import { CRMPlatform } from "@/enums/CRM.enum";

export const platformMapper = (platform: string | null): CRMPlatform | null => {
  if (!platform) {
    return null;
  }

  switch (platform.toLowerCase()) {
    case "hubspot":
      return CRMPlatform.HUBSPOT;
    default:
      return null;
  }
};

export const getPlatformName = (platform: CRMPlatform) => {
  switch (platform.toUpperCase()) {
    case CRMPlatform.HUBSPOT:
      return "hubspot";
    default:
      return null;
  }
};
